import {
  takeEvery,
  call,
  put,
  select,
} from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import {
  searchSuccess,
  searchFail,
  tourSearchRequest,
  setTourTripSearchParam, // TODO: tourSearchRequest
} from '../../slices/tripSearch';
import { tourSearchSuccess, updateTourSearchObj } from '../../slices/tour';
import { SearchStatus } from '../../../constants';

const queryString = require('query-string');

function* tourSearchWorker({ payload }) {
  try {
    const key = 'tour';
    const {
      startDate, endDate, destinations,
    } = yield select((store) => store.tripSearch.searchInputs[key]);
    if (payload.isTripSearch) {
      yield put(setTourTripSearchParam({
        ...payload,
        searchStatus: SearchStatus.SEARCHING,
      }));
    } else {
      updateTourSearchObj({
        ...payload, searchStatus: SearchStatus.SEARCHING,
      });
    }
    const query = {
      startDate,
      endDate,
      destinations: _.map(destinations, 'label'),
    };
    const qs = queryString.stringify(query, { skipNull: true });
    const url = `/tours/search?${qs}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (payload.isTripSearch) {
      yield put(searchSuccess(data));
    } else {
      yield put(tourSearchSuccess({ response: data }));
    }
  } catch (error) {
    yield put(searchFail(`${error}`));
  }
}

function* tourSearchWatcher() {
  yield takeEvery(tourSearchRequest.toString(), tourSearchWorker);
}

export default tourSearchWatcher;
